import React from "react";
import { number, object } from "prop-types";

import WruAlsoRead from "../../molecules/wru-also-read";
import NewsLetter from "./news-letter";
import { Standard337x280Container } from "../../rows/ad-free";

import "./story-sidebar.m.css";

const StorySideBar = ({ index, story }) => {
  return (
    <div styleName="side-bar-wrapper">
      <Standard337x280Container id="rightATF" story={story} />
      <NewsLetter />
      <WruAlsoRead index={index} story={story} />
      <Standard337x280Container id="rightstory2" story={story} />
    </div>
  );
};

StorySideBar.propTypes = {
  index: number,
  story: object,
};

export default StorySideBar;
